import React, { useState } from "react";
import "./sectionImgTitle.scss";
import CustomInput from "../../common/CustomInput";

const HeroBannerSection = ({ handleChange, data, errors }) => {
  const [previewImage, setPreviewImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
        handleChange({ target: { name: "banner_image", value: file } });
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      handleChange({ target: { name: "banner_image", value: null } });
    }
  };

  return (
    <div className="main_section_img_title">
      <p className="section_title">Hero Banner Section</p>
      <div className="titleAndDescription">
        <div className="width_50">
          <CustomInput
            label="Title"
            name="banner_title"
            isCompulsory={true}
            handleChange={handleChange}
            value={data.banner_title}
            error={errors.banner_title}
          />
        </div>

        <div className="width_50">
          <CustomInput
            label="Description"
            isCompulsory={true}
            handleChange={handleChange}
            name="banner_description"
            value={data.banner_description}
            error={errors.banner_description}
          />
        </div>
        <div className="width_50">
          <CustomInput
            label="Image"
            type="file"
            isCompulsory={true}
            accept="image/*"
            style={{
              padding: "13px",
            }}
            handleChange={handleImageChange}
            name="banner_image"
            error={errors.banner_image}
          />
          {previewImage && previewImage.startsWith("data:") ? (
            <img src={previewImage} alt="Preview" className="preview-image" />
          ) : data.banner_image ? (
            <img
              src={data.banner_image}
              alt="Preview"
              className="preview-image"
            />
          ) : null}
        </div>

        <div className="width_50">
          <CustomInput
            label="Button Link"
            isCompulsory={true}
            name="hero_button_link"
            handleChange={handleChange}
            value={data.hero_button_link}
            error={errors.hero_button_link}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroBannerSection;
